// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apply primary background color to the checkbox header column */
.ant-table-thead .ant-table-selection-column {
  background-color: #183d5d !important; /* Primary background */
  position: relative; /* Ensures child elements are positioned correctly */
}

/* Ensure checkbox remains visible and clickable */
.ant-table-thead .ant-checkbox-wrapper {
  position: relative;
  z-index: 10; /* Bring checkbox above the background */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* Ensure checkbox border is visible */
.ant-table-thead .ant-checkbox-inner {
  border-color: white !important; /* White border */
  background-color: white !important; /* White checkbox */
}

/* Ensure tick (✔) is visible */
.ant-table-thead .ant-checkbox-checked .ant-checkbox-inner::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 6px; /* Adjust width of the tick */
  height: 12px; /* Adjust height of the tick */
  border: solid white; /* Primary color for tick */
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -60%) rotate(45deg); /* Position and rotate tick */
}

.ant-table-cell-scrollbar {
  width: 2px !important;
  padding: 0px !important;
}

/* When the "Select All" checkbox is checked */
.ant-table-thead .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #007bff !important; /* Blue background */
  border-color: blue !important; /* Blue border */
}

/* Hover effect */
.ant-table-thead .ant-checkbox-wrapper:hover .ant-checkbox-inner {
  border-color: white !important;
}

.search-input {
  width: 350px !important;
  max-width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/onboarding/src/pages/Admin/SearchPage.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,oCAAoC,EAAE,uBAAuB;EAC7D,kBAAkB,EAAE,oDAAoD;AAC1E;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,WAAW,EAAE,wCAAwC;EACrD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,8BAA8B,EAAE,iBAAiB;EACjD,kCAAkC,EAAE,mBAAmB;AACzD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU,EAAE,6BAA6B;EACzC,YAAY,EAAE,8BAA8B;EAC5C,mBAAmB,EAAE,2BAA2B;EAChD,yBAAyB;EACzB,8CAA8C,EAAE,6BAA6B;AAC/E;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,oCAAoC,EAAE,oBAAoB;EAC1D,6BAA6B,EAAE,gBAAgB;AACjD;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B","sourcesContent":["/* Apply primary background color to the checkbox header column */\n.ant-table-thead .ant-table-selection-column {\n  background-color: #183d5d !important; /* Primary background */\n  position: relative; /* Ensures child elements are positioned correctly */\n}\n\n/* Ensure checkbox remains visible and clickable */\n.ant-table-thead .ant-checkbox-wrapper {\n  position: relative;\n  z-index: 10; /* Bring checkbox above the background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/* Ensure checkbox border is visible */\n.ant-table-thead .ant-checkbox-inner {\n  border-color: white !important; /* White border */\n  background-color: white !important; /* White checkbox */\n}\n\n/* Ensure tick (✔) is visible */\n.ant-table-thead .ant-checkbox-checked .ant-checkbox-inner::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px; /* Adjust width of the tick */\n  height: 12px; /* Adjust height of the tick */\n  border: solid white; /* Primary color for tick */\n  border-width: 0 2px 2px 0;\n  transform: translate(-50%, -60%) rotate(45deg); /* Position and rotate tick */\n}\n\n.ant-table-cell-scrollbar {\n  width: 2px !important;\n  padding: 0px !important;\n}\n\n/* When the \"Select All\" checkbox is checked */\n.ant-table-thead .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: #007bff !important; /* Blue background */\n  border-color: blue !important; /* Blue border */\n}\n\n/* Hover effect */\n.ant-table-thead .ant-checkbox-wrapper:hover .ant-checkbox-inner {\n  border-color: white !important;\n}\n\n.search-input {\n  width: 350px !important;\n  max-width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
